
import { Component, Prop, Vue } from 'vue-property-decorator';
import Grid from '@/components/event-flow/event-flow-grid/Grid.vue';

@Component({
    components: {
        Grid,
    },
})
export default class TimelineGrid extends Vue {
    @Prop() readonly timeValues!: string[];
}
